export default {
  // ----------------------------------------------- Provider Connection helpers

  // Returns the provider connection for the provided alias
  // (and optional account ID)
  providerConnection: state => (providerAlias, accountId) => {
    const connections = state.dataRegistry.providerConnections
    const items = (connections) ? connections.items : []
    return (accountId)
      ? items.find(item => item.provider_alias === providerAlias && item.thirdparty_account_id === accountId)
      : items.find(item => item.provider_alias === providerAlias)
  }
}
